import { render, staticRenderFns } from "./ArtworkDescription.vue?vue&type=template&id=3a55cf62&scoped=true"
import script from "./ArtworkDescription.vue?vue&type=script&lang=js"
export * from "./ArtworkDescription.vue?vue&type=script&lang=js"
import style0 from "./ArtworkDescription.vue?vue&type=style&index=0&id=3a55cf62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a55cf62",
  null
  
)

export default component.exports